import { Users, UserCheck } from "lucide-react";
import type { Performer } from "@shared/schema";

interface GenericEventStatsProps {
  performers: Performer[];
}

export default function GenericEventStats({
  performers,
}: GenericEventStatsProps) {
  const totalSignups = performers.length;
  const attendedCount = performers.filter((p) => p.attended).length;

  const stats = [
    {
      icon: Users,
      label: "Number of Signups",
      value: totalSignups,
      bgColor: "bg-blue-100",
      iconColor: "text-blue-600",
    },
    {
      icon: UserCheck,
      label: "Number of Attendees",
      value: attendedCount,
      bgColor: "bg-green-100",
      iconColor: "text-green-600",
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6 pt-4">
      {stats.map((stat, index) => (
        <div
          key={index}
          className="bg-white/20 backdrop-blur-xl rounded-2xl p-4 border border-white/20 relative group transition-all duration-300 hover:bg-white/25"
          style={{
            background: 'linear-gradient(135deg, rgba(255,255,255,0.25) 0%, rgba(255,255,255,0.1) 100%)',
            boxShadow: '0 8px 32px rgba(0,0,0,0.1), inset 0 1px 0 rgba(255,255,255,0.4)',
          }}
        >
          {/* Liquid Glass Specular Highlight */}
          <div 
            className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 rounded-2xl"
            style={{
              background: 'linear-gradient(135deg, rgba(255,255,255,0.4) 0%, transparent 50%, rgba(255,255,255,0.1) 100%)',
              pointerEvents: 'none',
            }}
          />
          
          <div className="flex items-center relative z-10">
            <div className={`p-2 ${stat.bgColor}/40 backdrop-blur-sm rounded-xl border border-white/30 shadow-lg`}
              style={{
                boxShadow: '0 4px 16px rgba(0,0,0,0.1), inset 0 1px 0 rgba(255,255,255,0.3)',
              }}>
              <stat.icon className={`h-5 w-5 ${stat.iconColor} drop-shadow-sm`} />
            </div>
            <div className="ml-3">
              <p className="text-sm font-medium text-slate-700/90 drop-shadow-sm">{stat.label}</p>
              <p className="text-2xl font-semibold text-slate-900/90 drop-shadow-sm">
                {stat.value}
              </p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}